import { gql } from 'graphql-request';

import { requestWithAuth } from '@/utilities/graphQLClient';

import {
  WATCHLIST_FRAGMENT,
  WATCHLIST_ITEM_FRAGMENT,
  WATCHLIST_NARRATIVE_FAIR_VALUE_FRAGMENT,
} from '@/hooks/useWatchlist';
import type {
  WatchlistFragmentType,
  WatchlistItemFragmentType,
} from '@/hooks/useWatchlist';

export type QueryResponse =
  | { errors: Error[] }
  | {
      createWatchlist: WatchlistFragmentType & {
        items: WatchlistItemFragmentType[];
      };
    };

interface Payload {
  name: string;
}

export const mutationFn = async (payload: Payload) => {
  const response = await requestWithAuth<QueryResponse>(
    gql`
      mutation createWatchlist($name: String!) {
        createWatchlist(name: $name) {
          ...watchlistFields
          items {
            ...watchlistItemFields
            ...narrativeFairValueFields
          }
        }
      }
      ${WATCHLIST_FRAGMENT}
      ${WATCHLIST_ITEM_FRAGMENT}
      ${WATCHLIST_NARRATIVE_FAIR_VALUE_FRAGMENT}
    `,
    {
      name: payload.name,
    }
  );

  if ('createWatchlist' in response) {
    return response.createWatchlist;
  }

  const firstErrorMessage = response.errors[0]?.message;
  throw new Error(firstErrorMessage ?? 'Failed to create Watchlist');
};
